<div class="modal-header">
  <h5 class="modal-title">Dispute Details</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  @if (disputeData) {
    <div class="container-fluid">
      <div class="row pt-2">
        <div class="col-md-3">
          Customer Name
        </div>
        <div class="col-md-9">
          : {{ disputeData?.customerId?.name }}
        </div>
        <div class="col-md-3">
          Email Id
        </div>
        <div class="col-md-9">
          : {{ disputeData?.customerId?.emailId }}
        </div>
        <div class="col-md-3">
          Merchant Name
        </div>
        <div class="col-md-9">
          : {{ disputeData?.transactionId?.merchantName }}
        </div>
        <div class="col-md-3">
          Transaction Id
        </div>
        <div class="col-md-9">
          : {{ disputeData?.transactionId?._id }}
        </div>
        <div class="col-md-3">
          Transaction Date
        </div>
        <div class="col-md-9">
          : {{ dateFormat(disputeData?.transactionId?.createdAt) }}
        </div>
        <div class="col-md-3">
          Transaction Amount
        </div>
        <div class="col-md-9">
          : {{ transactionAmount }}
        </div>
        <div class="col-md-3">
          Issue Type
        </div>
        <div class="col-md-9">
          : {{ disputeData?.issueType }}
        </div>
        <div class="col-md-3">
          Description
        </div>
        <div class="col-md-9">
          : {{disputeData?.description }}
        </div>
        <div class="col-md-6 mt-3">
          <!-- Accounts User: Can update status -->
          @if (originalStatus !== 'Resolved' && originalStatus !== 'Refunded' && originalStatus !== 'Rejected' && isAccountsUser) {
            <div class="form-group"
              >
              <label class="required">Update Status</label>
              <select
                class="form-control form-select"
                name="status"
                #status="ngModel"
                [(ngModel)]="selectedStatus"
                required>
                <option [ngValue]="null" disabled>
                  {{ disputeData?.status }}
                </option>
                @for (opt of statusOptions; track opt) {
                  <option [value]="opt.value">
                    {{ opt.label }}
                  </option>
                }
              </select>
              @if ((status.touched && status.invalid) || (!selectedStatus && newComment)) {
                <div class="text-danger">
                  Please select a status to proceed
                </div>
              }
            </div>
          }
          <!-- Non-Accounts User: Read-only status -->
          @if (!isAccountsUser) {
            <div class="form-group">
              <label>Status</label>
              <input
                type="text"
                class="form-control"
                [value]="disputeData?.status"
                readonly>
            </div>
          }
        </div>
        @if (disputeData?.userComments?.length && isAccountsUser) {
          <div class="col-md-12 mt-3">
            <div class="fw-bold">Comments</div>
            <div class="border rounded p-2 comment-history">
              @for (c of disputeData.userComments; track c) {
                <div class="mb-2 pb-2">
                  <div class="d-flex justify-content-between">
                    <div class="fw-bold">{{ c.user?.name }}</div>
                    <span class="text-muted small">{{ dateFormat(c.date) }}</span>
                  </div>
                  <div>{{ c.comment }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (originalStatus !== 'Resolved' && originalStatus !== 'Refunded' && originalStatus !== 'Rejected' && isAccountsUser) {
          <div class="col-md-12 mt-3">
            <div class="form-group">
              <label class="required">Add Comment</label>
              <textarea class="form-control comment-box" name="comments" #displayName="ngModel"
              [(ngModel)]="newComment" rows="2" required></textarea>
            </div>
          </div>
        }
      </div>
      @if (originalStatus !== 'Resolved' && originalStatus !== 'Refunded' && originalStatus !== 'Rejected' && isAccountsUser) {
        @if (updateError) {
          <div class="col-md-12 mt-2">
            <div class="alert alert-danger py-2 mb-0">{{ updateError }}</div>
          </div>
        }
        <div class="col-md-12 mt-2 text-center">
          <button [disabled]="!newComment || !selectedStatus || isUpdating" class="btn btn-primary active mt-4 w-50"
          (click)="onUpdate()">{{ isUpdating ? 'Updating...' : 'Update' }}</button>
        </div>
      }
    </div>
  }
</div>